export const LAYOUT_STYLE = {
  topNav: 'topNav',
  leftNav: 'leftNav',
}
